import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/react-state-lens";
import { useMutationWithErrorHandling } from "hooks/errorHandling";
import { UPDATE_QUOTE } from "../mutations";
import { emptyArray } from "constants/defaultValues";
import { useHistory } from "react-router";
import { invalidateApolloClientCache } from "utils/functions";
import { useApolloClient } from "@apollo/client";
import ActionsDialog from "features/common/components/ActionsDialog";
import { REMOVE_QUOTE_PARTNERS } from "features/client/mutations";
import { getTenant } from "providers/TenantProvider";
import { countryCodeConstants } from "features/common/constants";

function AssetsWarning(props) {
  const client = useApolloClient();
  const { openDialogLens, quoteId } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const { countryCode } = getTenant();
  const colesseeFunctionality = countryCode === countryCodeConstants.china;

  const handleClose = useCallback(() => (openDialogLens |> set)(false), [openDialogLens]);

  const [updateQuoteToClient] = useMutationWithErrorHandling(UPDATE_QUOTE);
  const [removeQuotePartners] = useMutationWithErrorHandling(REMOVE_QUOTE_PARTNERS);

  const goToClientStep = useCallback(async () => {
    (openDialogLens |> set)(false);
    await updateQuoteToClient({ variables: { input: { quoteId, assets: emptyArray } } });
    if (colesseeFunctionality) await removeQuotePartners({ variables: { quoteId } });
    invalidateApolloClientCache(client, { __typename: "Quote", quoteId: quoteId }, ["quoteAssets"]);
    history.push({ pathname: `/quotes/${quoteId}/client` });
  }, [openDialogLens, client, quoteId, history, colesseeFunctionality, updateQuoteToClient, removeQuotePartners]);

  return (
    <ActionsDialog
      open={openDialogLens |> get}
      handleClose={handleClose}
      title={t("Dialog.Caution")}
      message={t("DialogMessages.forTechnicalReasonsCantGoBack")}
      actions={[
        {
          caption: t("DialogMessages.keepAssets"),
          handle: () => {
            handleClose();
            return true;
          },
        },
        {
          caption: t("DialogMessages.discardAssets"),
          handle: async () => {
            await goToClientStep();
            return true;
          },
        },
      ]}
    />
  );
}

AssetsWarning.propTypes = {
  openDialogLens: PropTypes.object.isRequired,
  quoteId: PropTypes.number.isRequired,
};

export default AssetsWarning;
